export class AppPaymentAccountCreateRequestData {
    constructor(public bankAccountToken: string) {
    }
}
